interface ErrorBody {
  message?: string;
  impact?: Record<string, unknown>;
}

const IMPACT_LABELS: Record<string, string> = {
  cycles: 'Cycle',
  plans: 'Plan',
  athletePlans: "Plan d'athlète",
};

export const deleteErrorReason = (error: unknown): string => {
  const data = (error as { response?: { data?: ErrorBody } })?.response?.data;
  const impact = data?.impact
    ? Object.entries(data.impact).flatMap(([key, value]) =>
        Array.isArray(value)
          ? value.map((entry: { name?: string }) => `${IMPACT_LABELS[key] ?? key} : ${entry.name ?? '?'}`)
          : []
      )
    : [];
  if (impact.length > 0) return `utilisé par ${impact.join(', ')}`;
  if (data?.message) return data.message;
  return error instanceof Error ? error.message : 'erreur inconnue';
};

export interface BulkDeleteResult<T> {
  deleted: T[];
  failed: { row: T; reason: string }[];
}

/** Sequential on purpose: each row keeps its own server-side guard, and a blocked row does not stop the others. */
export const runBulkDelete = async <T>(rows: T[], remove: (row: T) => Promise<void>): Promise<BulkDeleteResult<T>> => {
  const result: BulkDeleteResult<T> = { deleted: [], failed: [] };
  for (const row of rows) {
    try {
      await remove(row);
      result.deleted.push(row);
    } catch (error) {
      result.failed.push({ row, reason: deleteErrorReason(error) });
    }
  }
  return result;
};
